// =====================================================
// PLIK: exportPDF.js — Roboto, polskie znaki, czerwone tło
// =====================================================

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerRobotoFont } from "./Roboto-regular";

/**
 * Eksportuje listę licencji do pliku PDF
 * @param {Array} licensesList
 */
export const exportPDF = (licensesList,todayISO,rptNumber ) => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "pt",
    format: "a4",
  });

  registerRobotoFont(doc);
  doc.setFont("Roboto", "normal");

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const today = new Date().toLocaleDateString("pl-PL");

  // Kolory
  const primaryColor = [173, 22, 14]; // #ad160e
 const SecprimaryColor = [240, 240, 245]; 

  const darkGray = [60, 60, 60];
  const lightGray = [245, 245, 245];

  // HEADER
  doc.setFillColor(...primaryColor);
  doc.rect(0, 0, pageWidth, 80, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFont("Roboto", "bold");
  doc.setFontSize(24);
  doc.text("HSHOP", 40, 45);

  doc.setFont("Roboto", "normal");
  doc.setFontSize(10);
  doc.text("System Zarządzania Licencjami", 40, 62);

  doc.setFontSize(9);
  doc.text(`Wygenerowano: ${today}`, pageWidth - 40, 45, { align: "right" });

  // TYTUŁ RAPORTU
  doc.setTextColor(...darkGray);
  doc.setFont("Roboto", "bold");
  doc.setFontSize(18);
  doc.text("Raport Licencji Klientów", 40, 115);

  // PODSUMOWANIE (jedna linia)
  const totalLicenses = licensesList.length;
  const totalRevenue = licensesList.reduce((sum, l) => sum + (parseFloat(l.price) || 0), 0);

  doc.setFillColor(...SecprimaryColor);
  doc.roundedRect(40, 140, pageWidth - 80, 40, 5, 5, "F"); // krótszy prostokąt, jedna linia

  doc.setFont("Roboto", "bold");
  doc.setFontSize(11);
  doc.setTextColor(...darkGray);
  doc.text(
    `Liczba licencji: ${totalLicenses}  |  Przychody: ${totalRevenue.toFixed(2)} PLN`,
    50,
    165
  );

  // TABELA
  doc.setTextColor(...darkGray);
  doc.setFont("Roboto", "bold");
  doc.setFontSize(12);
  doc.text("Lista do wystawienia", 40, 210);

  const tableColumn = [
    "Firma",
    "NIP",
    "Email",
    "Telefon",
    "Kwota",
    "Wystawiono",
  ];

  const tableRows = licensesList.map((l) => [
    l.shop_name ?? "-",
    l.nip ?? "-",
    l.client_email ?? "-",
    l.shop_phone ?? "-",
    l.price ? `${l.price} PLN` : "-",
    l.renewal_date ?? "-",
  ]);

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 225,
    theme: "grid",
    headStyles: { fillColor: SecprimaryColor, halign: "center", textColor: [...darkGray], fontStyle: "bold", font: "Roboto" },
    styles: { fontSize: 9, cellPadding: 6, font: "Roboto" },
    columnStyles: {
      0: { cellWidth: 100 },
      1: { cellWidth: 90 },
      2: { cellWidth: 150 },
      3: { cellWidth: 80, halign: "center" },
      4: { cellWidth: 90, halign: "center" },
      5: { cellWidth: 150, halign: "center" },
    
    },
    margin: { left: 40, right: 40 },
  });

  // STOPKA
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.5);
    doc.line(40, pageHeight - 50, pageWidth - 40, pageHeight - 50);

    doc.setFont("Roboto", "normal");
    doc.setFontSize(9);
    doc.setTextColor(120, 120, 120);
    doc.text(`Strona ${i} z ${pageCount}`, pageWidth / 2, pageHeight - 30, { align: "center" });

    doc.setFontSize(8);
    doc.text("HSHOP System | Raport poufny", 40, pageHeight - 30);

    doc.text(
      `ID raportu: ${rptNumber}`,
      pageWidth - 40,
      pageHeight - 30,
      { align: "right" }
    );
  }

  const fileName = `HSHOP_Raport_Licencji_${todayISO}.pdf`;
  doc.save(fileName);
};

export default exportPDF;
